import useAsyncMemo from '@onepercentio/one-ui/hooks/utility/useAsyncMemo'
import { LocalReferenceableUpload } from './DigitalTwin.types'
import {
  listImages,
  removeImage,
  uploadPossibleFile,
} from 'core/modules/firebase/service/marketplace'
import { AssetType } from 'core/logic/asset/asset.types'
import { useMemo } from 'react'
import BigNumber from 'bignumber.js'

export function useTaxRound(tax: number | undefined) {
  return useMemo(() => {
    if (tax !== undefined) return BigNumber(tax).multipliedBy(100).toNumber()
  }, [tax])
}

export function useMarketplaceDigitalTwinStorage(
  galleryId: string,
  tokenId: AssetType['tokenId'] | undefined,
  userId: string
) {
  const [initialImages, error, loading, retry] = useAsyncMemo<
    LocalReferenceableUpload[] | undefined
  >(async () => {
    if (!galleryId || !tokenId || !userId) return undefined
    const storageImages = await listImages(galleryId, userId, tokenId).catch((c) => {
      throw c
    })
    const files: LocalReferenceableUpload[] = []
    for (let item of storageImages.items) {
      const url = await item.getDownloadURL()
      files.push({
        objUrl: url,
        task: item,
      })
    }
    return files
  }, [galleryId, tokenId, userId])
  return {
    initialImages,
    removeImage(ref: LocalReferenceableUpload) {
      return removeImage(
        'snapshot' in ref.task
          ? ref.task.snapshot.ref.fullPath
          : ref.task.fullPath
      )
    },
    uploadImage(file: File) {
      return uploadPossibleFile(galleryId, userId, tokenId!, file)
    },
    error,
    loading,
    retry,
  }
}
